"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRedirectQueryParamFromLocation = exports.redirectQueryParamKey = void 0;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var redirectQueryParamKey = 'redirectTo';
exports.redirectQueryParamKey = redirectQueryParamKey;

var getRedirectQueryParamFromLocation = function getRedirectQueryParamFromLocation(_ref) {
  var _ref$location = _ref.location,
      pathname = _ref$location.pathname,
      search = _ref$location.search,
      defaultRedirect = _ref.defaultRedirect;
  if (pathname === defaultRedirect && !search) return {};else return _defineProperty({}, redirectQueryParamKey, "".concat(pathname).concat(search));
};

exports.getRedirectQueryParamFromLocation = getRedirectQueryParamFromLocation;